export default "__VITE_ASSET__BWpNYBx1__"